const getInnerTextFromString = (htmlString) => {
  if (htmlString && global.document) {
    const div = global.document.createElement('div');
    div.innerHTML = htmlString.trim();
    const html = div.firstChild;
    return html.textContent.trim();
  }

  return '';
};

export default getInnerTextFromString;
